import React from 'react';
import { useLocation } from 'react-router';

import ExamForm from 'Components/ExamForm';

export default function ExamUpdate() {
  const location = useLocation();

  return (
    <div>
      <ExamForm updateId={location.state.ICLId} />
    </div>
  );
}
